/**
 * Utilitários de formatação de moeda e números
 * Usa Intl.NumberFormat nativo — zero dependências
 */

const CURRENCY_SYMBOLS = {
  BRL: 'R$',
  USD: '$',
  EUR: '€',
  MXN: 'MX$',
  COP: 'COP$',
  ARS: 'AR$',
};

/**
 * Formata valor monetário com símbolo e locale correto
 * formatCurrency(697)              → "R$ 697,00"
 * formatCurrency(139, 'USD')       → "$139.00"
 * formatCurrency(129, 'EUR', 'de-DE') → "129,00 €"
 */
export function formatCurrency(value, currency = 'BRL', locale = 'pt-BR') {
  if (value === null || value === undefined || isNaN(value)) return '—';
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  } catch {
    // fallback manual se moeda não suportada
    const symbol = CURRENCY_SYMBOLS[currency] || currency;
    return `${symbol} ${Number(value).toFixed(2)}`;
  }
}

/**
 * Formata número com separador de milhar no locale correto
 * formatNumber(1850)          → "1.850"  (pt-BR)
 * formatNumber(1850, 'en-US') → "1,850"
 */
export function formatNumber(value, locale = 'pt-BR') {
  if (value === null || value === undefined || isNaN(value)) return '—';
  return new Intl.NumberFormat(locale).format(value);
}

/**
 * Retorna o símbolo da moeda
 * currencySymbol('BRL') → 'R$'
 * currencySymbol('USD') → '$'
 */
export function currencySymbol(currency = 'BRL') {
  return CURRENCY_SYMBOLS[currency] || currency;
}

/**
 * Retorna o locale padrão para uma moeda
 */
export function currencyLocale(currency = 'BRL') {
  const map = { BRL: 'pt-BR', USD: 'en-US', EUR: 'de-DE', MXN: 'es-MX', COP: 'es-CO', ARS: 'es-AR' };
  return map[currency] || 'pt-BR';
}

/**
 * Formata preço de tier/conector para exibição no marketplace
 * Aceita número ou string (ex: "Sob consulta")
 */
export function formatPrice(price, currency = 'BRL', perMonth = true, locale) {
  if (!price && price !== 0) return '—';
  if (typeof price === 'string' && isNaN(Number(price))) return price; // "Sob consulta"
  const loc = locale || currencyLocale(currency);
  const formatted = formatCurrency(Number(price), currency, loc);
  return perMonth ? `${formatted}/mês` : formatted;
}
